import start from './start'
import reset from './reset'
import quickTest from './quickTest'
import quickTestError from './quickTestError'
import fullTest from './fullTest'
import subIDsesIDmismatchTest from './subSesMismatchTest'

const options = {}
const issues = []
const subIDsesIDmismatchtest = subIDsesIDmismatchTest

export {
  options,
  issues,
  start,
  quickTestError,
  quickTest,
  fullTest,
  subIDsesIDmismatchtest,
  reset,
}

export default {
  options,
  issues,
  start,
  quickTestError,
  quickTest,
  fullTest,
  subIDsesIDmismatchtest,
  reset,
}
